var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreePoints1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5294 17.4118H9.70588C8.4578 17.4118 7.26084 17.9076 6.37832 18.7901C5.4958 19.6726 5 20.8696 5 22.1176V31.5294C5 32.7775 5.4958 33.9744 6.37832 34.857C7.26084 35.7395 8.4578 36.2353 9.70588 36.2353H12.0588V45.6471C12.0588 46.2711 12.3067 46.8696 12.748 47.3108C13.1892 47.7521 13.7877 48 14.4118 48H19.1176C19.7417 48 20.3402 47.7521 20.7814 47.3108C21.2227 46.8696 21.4706 46.2711 21.4706 45.6471V36.2353H28.5294L40.2941 45.6471V8L28.5294 17.4118ZM50.8824 26.8235C50.8824 30.8471 48.6235 34.4941 45 36.2353V17.4118C48.6 19.1765 50.8824 22.8235 50.8824 26.8235Z",
    fill: "#1CCEDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreePoints1);
export default __webpack_public_path__ + "static/media/threePoints1.d0e94bb89039f15fa555d402a14b7180.svg";
export { ForwardRef as ReactComponent };